import { AuthHeader, AuthHeaderWrapper, AuthFooter } from "@shared/components";
import { useSharedGlobalConfig, useFlippers } from "@shared/hooks";
import { Navigate } from "@shared/react-router-dom";
import { SignInBlock } from "@unauthenticated/shared/components";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { PageContent, Page } from "@unauthenticated/signupSignin/components";

interface Props {
  additionalAttributes?: any;
}

const EmersonSignInPage = ({ additionalAttributes }: Props) => {
  const { isUS } = useSharedGlobalConfig();
  const [isLighthouseEnabled] = useFlippers("project_lighthouse_eev2");

  if (!isUS || !isLighthouseEnabled) return <Navigate to={authRoutes.login} />;

  return (
    <Page data-e2e="sign-in-page">
      <AuthHeaderWrapper includeBorder>
        <AuthHeader showFromEmersonEcologics />
      </AuthHeaderWrapper>
      <PageContent>
        <SignInBlock additionalAttributes={additionalAttributes} />
        <AuthFooter />
      </PageContent>
    </Page>
  );
};

export { EmersonSignInPage };
